import axios from 'axios';
import baseUrl from '../utils/baseUrl';

let url = baseUrl;

export const PAYER_LOOKUP_REQUEST = 'PAYER_LOOKUP_REQUEST';
export const PAYER_LOOKUP_SUCCESS = 'PAYER_LOOKUP_SUCCESS';
export const PAYER_LOOKUP_FAIL = 'PAYER_LOOKUP_FAIL';
export const PAYER_LOOKUP_RESET = 'PAYER_LOOKUP_RESET';

export const lookupPayerByTin = (tin) => async (dispatch, getState) => {
   try {
      dispatch({ type: PAYER_LOOKUP_REQUEST });

      const {
         userLogin: { userInfo }
      } = getState();

      const { tenantDashboardDetails: { tenant } } = getState();

      const config = {
         headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userInfo.accessToken}`,
            'tenantId': `${tenant?.singleTenant?._id}`
         }
      };

      const { data } = await axios.get(
         `${url}/payers/lookup?tin=${encodeURIComponent(tin)}`,
         config
      );

      dispatch({
         type: PAYER_LOOKUP_SUCCESS,
         payload: data
      });

      return data;
   } catch (error) {
      const message =
         error.response && error.response.data.message
            ? error.response.data.message
            : error.message;

      dispatch({
         type: PAYER_LOOKUP_FAIL,
         payload: message
      });

      return { found: false, message };
   }
};

export const resetPayerLookup = () => (dispatch) => {
   dispatch({ type: PAYER_LOOKUP_RESET });
};
